// Centralizes the various hashtag-related regex we use in this extension. Just making sure they're all easy to find.
/**
 * Tests if a hashtag is valid, excluding the hash
 */ export const hashtagTextRegex = RegExp("^[\\w\\p{L}]+$", "u");
/**
 * Tests if a hashtag is valid, including the hash
 */ export const hashtagWithHashRegex = RegExp("^#[\\w\\p{L}]+$", "u");
/**
 * Detects hashtags within a block of text.
 */ export const hashtagInTextBlockRegex = RegExp("\\B#[\\w\\p{L}]+", "gu");
/**
 * Used with our paste handler.
 */ export const hashtagPasteRegex = RegExp("#[\\w\\p{L}]+", "gu");

//# sourceMappingURL=hashtagRegex.js.map